import React from 'react'
import { findPlatform } from 'config/platforms'
import ZendeskSupportButton from './ZendeskSupportButton'
import EmailSupportButton from './EmailSupportButton'

const FALLBACK_PLATFORM = {
  title: 'FocusVision',
  supportEmail: 'support@focusvision.com'
}

const FormatPlatformErrorMessage = (platformName, error) =>
  `Hi,

I am unable to log in to ${platformName} with my FV login.

My error was: ${error}`

export default ({ platformId, error, ...rest }) => {
  const platform = findPlatform(platformId) || FALLBACK_PLATFORM
  const errorMessage = FormatPlatformErrorMessage(platform.title, error)
  return platform.zendeskHost ? (
    <ZendeskSupportButton
      zendeskHost={platform.zendeskHost}
      message={errorMessage}
      {...rest}
    />
  ) : (
    <EmailSupportButton
      email={platform.supportEmail}
      message={errorMessage}
      {...rest}
    />
  )
}



// WEBPACK FOOTER //
// ./src/routes/errors/components/SupportButton.js